import React from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";
import ChevronRight from "@assets/svg/ChevronRight";
import getWalletIcon from "./WalletIcon";
import { WalletTxnType } from "../utils";
import AggCardTag from "./AggCardTag";
import testIds from "@constants/testIds";

type AggTransactionCardProps = {
  item: {
    key: string;
    title: string;
    value: number;
    value_txt: string;
    nav_to: string;
    types: string[];
    summary_amount_status: any;
  };
  onPress: () => void;
};

const AggTransactionCard: React.FC<AggTransactionCardProps> = ({
  item,
  onPress,
}) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={styles.aggTransactionContainer}
      activeOpacity={0.7}
      testID={`${item?.key}`}
    >
      {getWalletIcon(item.key)}
      <View style={styles.aggTransactionText}>
        <View
          style={styles.aggTransactionTextContainer}
          testID={`${item?.key}+${item?.title}`}
        >
          <Text variant="body_text_1" style={styles.aggTransactionAmount}>
            {item?.title}
          </Text>
          <Text variant="heading_24" style={styles.aggTransactionDescription}>
            {item?.value_txt}
          </Text>
        </View>
        {item?.key == WalletTxnType.DELIVERY_FEE && (
          <AggCardTag
            processing={item?.summary_amount_status?.processing}
            processed={item?.summary_amount_status?.processed}
          />
        )}
      </View>
      <View
        style={styles.chevron}
      >
        <ChevronRight pathFill={color.darkGrey} style={styles.chevronIcon} />
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  aggTransactionContainer: {
    flexDirection: "row",
    alignItems: "center",
    padding: 10,
    paddingHorizontal: 16,
    backgroundColor: color.white,
    borderRadius: 8,
    elevation: 1,
    marginBottom: 12,
    marginHorizontal: 16,
  },
  aggTransactionTextContainer: {
    marginLeft: 12,
    alignItems: "flex-start",
    marginRight: 6,
  },
  aggTransactionAmount: {
    color: color.black06,
  },
  aggTransactionDescription: {
    color: color.mediumBlack,
    lineHeight: 30,
  },
  chevronIcon: {
    height: 12,
    width: 12,
  },
  chevron: {
    position: "absolute",
    right: 16,
  },
  aggTransactionText: {
    flexDirection: "row",
    justifyContent: "space-between",
    flex: 1,
  },
});

export default AggTransactionCard;
